function CustomCssVariables() {
  return {
    variables: {
      "--progix-primary": "#0056B3",
      "--progix-text-secondary": "#7E7E7E",
    },
    light: {},
    dark: {},
  };
}

export default CustomCssVariables;
